import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { components } from "react-select";
import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import { CircleLoading, CopyLinkIcon, GlobeIcon, LockIcon, ViewIcon } from "../../../assets/SvgIcons";
import { CheckIcon } from "../../../iconshere";
import apiClient from "../../../apiClient";
import { SEARCH_USER_GROUP_DATA, SHARE_PROJECT, SHARE_PROJECT_USERS } from "../../../apiClient/apiEndpoints";

const MultiValueLabel = (props) => {
  return (
    <components.MultiValueLabel>
      <p className="label-tag">{props.data.name}</p>
    </components.MultiValueLabel>
  );
};

const ShareProject = ({ showShareModal, closeShareProjectModal, shareProject, usersList }) => {
  const docAccess = "private";
  const accesControls = [
    {
      name: "View",
      access: "public",
      info: "Anyone with the link can view",
      iconURL: <ViewIcon />,
    },
    {
      name: "Restricted",
      access: "private",
      info: "Only people with access can open with the link",
      iconURL: <LockIcon />,
    },
    // {
    //   name: "Anyone with the link",
    //   access: "anyone",
    //   info: "Anyone on the internet with the link can view",
    //   iconURL: <GlobeIcon />,
    // },
  ];

  const [loadModal, setLoadModal] = useState(false);
  const [saveLoad, setSaveLoad] = useState(false);
  const [type, setType] = useState("editor");
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [projectShareList, setProjectShareList] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);

  useEffect(() => {
    let filteredUsersList = usersList.filter((user) => user.uuid !== userData.user.uuid);
    let userUuids = projectShareList.map((user) => user.uuid);
    filteredUsersList = filteredUsersList.filter((user) => !userUuids.includes(user.uuid));

    let optionsList = filteredUsersList.map((e, i) => {
      return {
        value: e.uuid,
        name: e.name,
        label: (
          <div className="label-person">
            {e.avatar ? <img src={e.avatar} alt="profile" /> : <span className="ini"> {e.name.charAt(0)} </span>}
            <span>
              <p>{e.name}</p>
              <p>{e.email}</p>
            </span>
          </div>
        ),
        categoryType: "user",
      };
    });

    setOptionList(optionsList);
  }, [usersList, projectShareList]);

  const handleTypeChange = (newType) => {
    setType(newType);
  };

  const close = () => {
    closeShareProjectModal();
  };

  const getSharedUsersList = async () => {
    try {
      let data = await apiClient.get(`${configData.config.API_URL}${SHARE_PROJECT_USERS}/${shareProject.id}`);
      data = data.map((e) => ({ ...e, edit: false }));
      setProjectShareList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    showShareModal && getSharedUsersList();
  }, [showShareModal, shareProject]);

  const handleSelectUsers = (selectedOptions) => {
    setSelectedUsers(selectedOptions);
  };

  const handleSaveShareProject = async () => {
    if (loading) return;
    setLoading(true);
    let editUser = projectShareList
      .filter((e) => e.edit === true)
      .map((f) => ({ id: f.uuid, type: f.allocation.type.toLowerCase(), categoryType: f.categoryType }));
    let shareUserList = selectedUsers.map((e) => ({ id: e.value, type: type, categoryType: e.categoryType }));

    let bodyData = {
      data: [...shareUserList, ...editUser],
    };

    setSelectedUsers([]);
    try {
      await apiClient.post(`${configData.config.API_URL}${SHARE_PROJECT}/${shareProject.id}`, bodyData);
      getSharedUsersList();
      close();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUserType = (uuid, newType) => {
    const updatedUsers = projectShareList.map((user) =>
      user.uuid === uuid ? { ...user, edit: true, allocation: { ...user.allocation, type: newType } } : user
    );
    setProjectShareList(updatedUsers);
  };

  const fetchUserAndGroupData = async (slug) => {
    try {
      const res = await apiClient.get(`${configData.config.API_URL}${SEARCH_USER_GROUP_DATA}`, {
        params: { slug },
      });
      return res.map((item) => {
        return {
          value: item.uuid,
          name: item.name,
          label: (
            <div className="label-person">
              {item.avatar ? (
                <img src={item.avatar} alt="profile" />
              ) : (
                <span className="ini"> {item.name.charAt(0)} </span>
              )}
              <span>
                <p>{item.name}</p>
                <p>{item.email || ""}</p>
              </span>
            </div>
          ),
          categoryType: "groupId" in item ? "user" : "group",
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal centered show={showShareModal} onHide={close}>
      <div className="share-modal">
        {!loadModal ? (
          <>
            <div className="modal-head">
              <h6>Share {shareProject.name}</h6>
              <div className="select-parent">
                <AsyncSelect
                  defaultOptions={optionList.slice(0, 25)}
                  loadOptions={fetchUserAndGroupData}
                  components={{ MultiValueLabel }}
                  getOptionLabel={(item) => item.label}
                  isMulti
                  name="usersList"
                  value={selectedUsers}
                  placeholder="Select user"
                  filterOption={(option, inputValue) =>
                    option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                  }
                  onChange={handleSelectUsers}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    colors: {
                      ...theme.colors,
                      primary50: "#ca373c50",
                      primary25: "#ca373c50",
                      primary: "#ca373c70",
                      danger: "#000000",
                      neutral30: "#00000050",
                    },
                  })}
                />
                {selectedUsers?.length > 0 && (
                  <div className="dropdown-here">
                    <Dropdown className="custom-role">
                      <Dropdown.Toggle>{type === "editor" ? "Editor" : "Viewer"}</Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div className="options">
                          {["editor", "viewer"].map((role) => {
                            return (
                              <Dropdown.Item eventKey={role} onClick={() => handleTypeChange(role)}>
                                <span className="option">
                                  <span className="checked">{type === role && <CheckIcon />}</span>
                                </span>
                                <span> {role.charAt(0).toUpperCase() + role.slice(1)}</span>
                              </Dropdown.Item>
                            );
                          })}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-body">
              <div className="access">
                <h6>Who has access</h6>
                <div className="user-list">
                  {projectShareList.map((item, index) => {
                    const { uuid, avatar, name, email, allocation } = item;
                    let roleType = allocation.type.toUpperCase();
                    const isCurrentUser = uuid === userData.user.uuid;

                    return (
                      <>
                        <div className={roleType == "remove" ? "user-item removed" : "user-item"}>
                          <div className="user-info">
                            {avatar ? (
                              <img src={avatar} alt={name} referrerPolicy={"no-referrer"} />
                            ) : (
                              <span className="init">{name?.charAt(0).toUpperCase()}</span>
                            )}

                            <span className="name-email">
                              <p className="name">
                                {name}
                                {isCurrentUser && <span> (You) </span>}
                              </p>
                              <p className="email">{email}</p>
                            </span>
                          </div>
                          <div className="dropdown-here">
                            {roleType === "OWNER" ? (
                              <p className="owner"> Owner </p>
                            ) : (
                              <Dropdown>
                                <Dropdown.Toggle disabled={roleType === "OWNER"}>{roleType}</Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="options">
                                    {["EDITOR", "VIEWER", "REMOVE"].map((type) => (
                                      <Dropdown.Item
                                        key={type}
                                        className={roleType === type ? "menu-item selected" : "menu-item"}
                                        onClick={() => roleType !== type && handleChangeUserType(uuid, type)}
                                      >
                                        <span className="option">
                                          {" "}
                                          <span className="checked">{roleType === type && <CheckIcon />}</span>
                                          <span>{type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()} </span>
                                        </span>
                                      </Dropdown.Item>
                                    ))}
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
              {/* <div className="access gen">
                <h6> General Access </h6>
                <div className="gen-dropdown">
                  <span className="gen-icon">{docAccess == "private" ? <LockIcon /> : <GlobeIcon />}</span>
                  <div className="drop-info">
                    <div className="dropdown-here">
                      <Dropdown className="">
                        <Dropdown.Toggle>
                          {accesControls?.filter((e) => e.access == docAccess)[0]?.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {accesControls?.map((ele) => {
                            return (
                              <div className="options">
                                <Dropdown.Item onClick={() => {}}>
                                  <div className="option">
                                    <span className="checked">{ele?.access == docAccess && <CheckIcon />}</span>
                                    <span>{ele.name}</span>
                                  </div>
                                </Dropdown.Item>
                              </div>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <p>{accesControls?.filter((e) => e.access == docAccess)[0]?.info}</p>
                  </div>
                </div>
              </div> */}
              <div className="share-footer justify-content-end">
                {/* <button className="link">
                  <CopyLinkIcon />
                  Copy link
                </button> */}
                <button className="save" onClick={handleSaveShareProject}>
                  {saveLoad ? (
                    <>
                      <div className="loading-button">
                        <CircleLoading />
                      </div>
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="load-modal">
              <div className="loading-button">
                <CircleLoading />
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ShareProject;
